import img1 from './images/10001.jpg';
import img2 from './images/10002.jpg';
import img3 from './images/10003.jpg';
import img4 from './images/10004.jpg';

export const img= [img4,img2,img4,img3,img1];